import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashSummaryDTO, CashSummaryState } from "../../../types/cash/cashSummary";

const initialState: CashSummaryState = {
  summary: null,
  loading: false
};

const cashSummarySlice = createSlice({
  name: "cashSummary",
  initialState,
  reducers: {
    setCashSummary(state, action: PayloadAction<CashSummaryDTO | null>) {
      state.summary = action.payload;
    },

    clearCashSummary(state) {
      state.summary = null;
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    }
  }
});

export const {
  setCashSummary,
  clearCashSummary,
  setLoading
} = cashSummarySlice.actions;

export default cashSummarySlice.reducer;